var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotography({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0a0a0a",
    stroke: "#0a0a0a",
    strokeWidth: 19.456,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M894.8 241H729.3v-26.1c0-43.2-35.2-78.4-78.4-78.4H372.3c-43.2 0-78.4 35.2-78.4 78.4V241H128.4c-33.6 0-61 27.3-61 61v522.5c0 33.6 27.3 61 61 61h766.4c33.6 0 61-27.3 61-61V301.9c0-33.6-27.4-60.9-61-60.9z m8.7 583.4c0 4.8-3.9 8.7-8.7 8.7H128.4c-4.8 0-8.7-3.9-8.7-8.7V301.9c0-4.8 3.9-8.7 8.7-8.7H320c14.4 0 26.1-11.7 26.1-26.1v-52.2c0-14.4 11.7-26.1 26.1-26.1H651c14.4 0 26.1 11.7 26.1 26.1v52.2c0 14.4 11.7 26.1 26.1 26.1h191.6c4.8 0 8.7 3.9 8.7 8.7v522.5zM511.6 397.7c-91.2 0-165.5 74.2-165.5 165.4s74.2 165.4 165.5 165.4 165.5-74.2 165.5-165.4-74.3-165.4-165.5-165.4z m0 278.7c-62.4 0-113.2-50.8-113.2-113.2 0-62.4 50.8-113.2 113.2-113.2s113.2 50.8 113.2 113.2c0 62.4-50.8 113.2-113.2 113.2z",
    fill: "#0d0d0d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotography);
export default __webpack_public_path__ + "static/media/photography.db0ebd982bd8ddb284fac89cb2c13908.svg";
export { ForwardRef as ReactComponent };